(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["static-announcement"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const track = document.querySelector('.scrolling-track');
  if (!track) return;

  const speed = parseFloat(track.dataset.speed) || 20;

  let pos = 0;

  // Duplicate content once
  track.innerHTML += track.innerHTML;

  function step() {
    pos -= speed * 0.05; // lower multiplier = slower movement

    if (Math.abs(pos) >= track.scrollWidth / 2) {
      pos = 0;
    }

    track.style.transform = `translateX(${pos}px)`;
    requestAnimationFrame(step);
  }

  step();
});

  } catch(e) { console.error(e); }
})();
})();
